import { Chip } from '@mui/material';
import { LinkAccountStatus, LinkAccountStatusValue } from 'src/models';
import { ColorConstant } from 'src/styles';

const getLinkAccountStatusTagPalette = (status: LinkAccountStatusValue): { background: string; color: string } => {
  switch (status) {
    case LinkAccountStatusValue.Linked:
      return { background: ColorConstant.GREEN2, color: ColorConstant.GREEN7 };
    case LinkAccountStatusValue.Failed:
      return { background: ColorConstant.RED2, color: ColorConstant.RED7 };
    default:
      return {
        background: ColorConstant.ORANGE1,
        color: ColorConstant.ORANGE7,
      };
  }
};

export const LinkAccountStatusChip = ({ value }: { value: LinkAccountStatus }) => {
  return <Chip label={value.label} sx={getLinkAccountStatusTagPalette(value.value)} />;
};
